export default __webpack_public_path__ + "static/media/desk-with-notes-calculator-and-coffee.3ae167fe.svg";